module.exports = __webpack_public_path__ + "img/tracks.20d90652.svg";